import { PropertyKindEnum } from '../../types/enums';

export const PROPERTY_AD_EDITOR_PROPERTY_KIND_OPTIONS = [
  { label: 'Apartment', value: PropertyKindEnum.Apartment },
  { label: 'Villa', value: PropertyKindEnum.Villa },
  { label: 'Townhouse', value: PropertyKindEnum.Townhouse },
  { label: 'Penthouse', value: PropertyKindEnum.Penthouse },
  { label: 'Hotel Apartment', value: PropertyKindEnum.HotelApartment },
  { label: 'Residential Land', value: PropertyKindEnum.ResidentialLand },
  { label: 'Floor', value: PropertyKindEnum.Floor },
  { label: 'Whole Building', value: PropertyKindEnum.CommercialBuilding },
  { label: 'Shop', value: PropertyKindEnum.Shop },
  { label: 'Office', value: PropertyKindEnum.Office },
  { label: 'Warehouse', value: PropertyKindEnum.Warehouse },
  { label: 'Commercial Villa', value: PropertyKindEnum.CommercialVilla },
  { label: 'Commercial Land', value: PropertyKindEnum.CommercialLand },
  { label: 'Industrial Land', value: PropertyKindEnum.IndustrialLand },
] as const;

export const PROPERTY_AD_EDITOR_SELECTABLE_PROPERTY_KINDS =
  PROPERTY_AD_EDITOR_PROPERTY_KIND_OPTIONS.map(({ value }) => value);

const selectablePropertyKinds = new Set<PropertyKindEnum>(
  PROPERTY_AD_EDITOR_SELECTABLE_PROPERTY_KINDS
);

export const isPropertyAdEditorSelectablePropertyKind = (propertyKind: PropertyKindEnum): boolean =>
  selectablePropertyKinds.has(propertyKind);
